import loadsJs from 'loads-js';
import { encode } from 'querystring';

import { GTM_CN_KEY, GTM_COM_KEY, GTM_PAGE_TYPE, GTM_SCRIPT } from '../settings/shared';
import { getChannel } from '../actions/nav';
import { language, countryCode } from './translator';
import { extension, parsedUrl } from './url';

export default function () {
  window.dataLayer = [];
  window.dataLayer.push({
    pageType: GTM_PAGE_TYPE,
    pageVirtualPath: parsedUrl.path,
    language: language,
    univers: getChannel().toUpperCase(),
    country: countryCode.toLowerCase(),
    subUniverse: 'Store Locator',
    topCategory: '',
    categories: '',
    subCategory: ''
  });
  window.dataLayer.push({
    'gtm.start': new Date().getTime(), event: 'gtm.js'
  });

  if (extension !== 'cn') {
    const params = {
      id: GTM_COM_KEY
    };
    loadsJs(GTM_SCRIPT + '?' + encode(params));
  } else {
    const params = {
      id: GTM_CN_KEY
    };
    loadsJs(GTM_SCRIPT + '?' + encode(params));
  }
}

export function trackAppointment(boutiqueName) {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Boutique appointment',
    eventLabel: boutiqueName
  });
}

export function trackFilter(filterName) {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Filter Usage',
    eventLabel: filterName
  });
}

export function trackItinerary(boutiqueName, transportationMode) {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Follow itinerary',
    eventLabel: `${boutiqueName} - ${transportationMode}`
  });
}

export function trackSearch(searchTerm) {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Store Locator Search usage',
    eventLabel: searchTerm
  });
}

export function trackShare(boutiqueName) {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Share this shop',
    eventLabel: boutiqueName
  });
}

export function trackBooxi() {
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: GTM_PAGE_TYPE,
    eventAction: 'Book an appointment',
    eventLabel: '',
    eventValue: '',
    ecommerce: null
  });
}



// WEBPACK FOOTER //
// ./src/services/gtm.js